import { render, staticRenderFns } from "./onlineGoods.vue?vue&type=template&id=013f8b3a&scoped=true&"
import script from "./onlineGoods.vue?vue&type=script&lang=js&"
export * from "./onlineGoods.vue?vue&type=script&lang=js&"
import style0 from "./onlineGoods.vue?vue&type=style&index=0&id=013f8b3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013f8b3a",
  null
  
)

export default component.exports